import { CommentQuoteOutlineIcon } from './CommentQuoteOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5510BB9F-2D63-471A-86F3-732E91A513E4
 * name comment-quote-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-quote-outline.svg
 * tags
 */
export const FeedbackOutlineIcon = CommentQuoteOutlineIcon;
export default FeedbackOutlineIcon